import React from "react";
var __jsx = React.createElement;
import ServiceCenterCard from "./components/ServiceCenterCard";
import SCFiltersHeader from "./components/SCFiltersHeader/SCFiltersHeader";
import SCNoResults from "./components/SCNoResults/SCNoResults";
import stl from "./ServiceCentersFiltersComponent.module.css";
var ServiceCentersFiltersComponent = function ServiceCentersFiltersComponent(_ref) {
  var filters = _ref.filters,
    availableSCData = _ref.availableSCData,
    onFiltersChange = _ref.onFiltersChange,
    availableSCResults = _ref.availableSCResults,
    popUpData = _ref.popUpData,
    setPopUpData = _ref.setPopUpData,
    showPopUp = _ref.showPopUp,
    setShowPopUp = _ref.setShowPopUp,
    onSingleFilterChange = _ref.onSingleFilterChange,
    resultsLoading = _ref.resultsLoading,
    loading = _ref.loading;
  return /*#__PURE__*/React.createElement("div", {
    className: stl.SCResultsContainer
  }, /*#__PURE__*/React.createElement(SCFiltersHeader, {
    filters: filters,
    availableSCData: availableSCData,
    onFiltersChange: onFiltersChange,
    popUpData: popUpData,
    setPopUpData: setPopUpData,
    showPopUp: showPopUp,
    setShowPopUp: setShowPopUp,
    onSingleFilterChange: onSingleFilterChange,
    loading: loading
  }), /*#__PURE__*/React.createElement("div", {
    className: stl.SCCardsContainer
  }, availableSCResults.length ? availableSCResults === null || availableSCResults === void 0 ? void 0 : availableSCResults.map(function (data, idx) {
    return /*#__PURE__*/React.createElement(ServiceCenterCard, {
      key: idx,
      data: data
    });
  }) : !resultsLoading && /*#__PURE__*/React.createElement(SCNoResults, null)));
};
export default ServiceCentersFiltersComponent;